import { createApp } from 'vue'
import NewCarLoanCalculatorResult from './NewCarLoanCalculatorResult'
import handleComponentProps from '../../../foundation/js/utils/handleComponentProps.js'

const el = '.nyk-component--new-car-loan-calculator-result'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((NewCarLoanCalculatorResultDOM) => {
            const props = handleComponentProps(NewCarLoanCalculatorResult, NewCarLoanCalculatorResultDOM)
            const component = createApp(NewCarLoanCalculatorResult, props).use(Store)
            component.mount(NewCarLoanCalculatorResultDOM)
        })
    }
}
